var _path, _g, _path2, _g2, _path3, _g3, _path4, _g4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_587_2986",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.814 7.20207H8.18605V10.293H12.5767C12.1674 12.2566 10.4558 13.3839 8.18605 13.3839C5.50698 13.3839 3.34884 11.2748 3.34884 8.65662C3.34884 6.03843 5.50698 3.92934 8.18605 3.92934C9.33953 3.92934 10.3814 4.32934 11.2 4.98389L13.5814 2.65662C12.1302 1.42025 10.2698 0.656616 8.18605 0.656616C3.64651 0.656616 0 4.22025 0 8.65662C0 13.093 3.64651 16.6566 8.18605 16.6566C12.2791 16.6566 16 13.7475 16 8.65662C16 8.18389 15.9256 7.6748 15.814 7.20207Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_587_2986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.744141 13.3839V3.92938L5.58144 8.65665L-0.744141 13.3839Z",
    fill: "#FBBC05"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_587_2986",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.814 7.20207H8.18605V10.293H12.5767C12.1674 12.2566 10.4558 13.3839 8.18605 13.3839C5.50698 13.3839 3.34884 11.2748 3.34884 8.65662C3.34884 6.03843 5.50698 3.92934 8.18605 3.92934C9.33953 3.92934 10.3814 4.32934 11.2 4.98389L13.5814 2.65662C12.1302 1.42025 10.2698 0.656616 8.18605 0.656616C3.64651 0.656616 0 4.22025 0 8.65662C0 13.093 3.64651 16.6566 8.18605 16.6566C12.2791 16.6566 16 13.7475 16 8.65662C16 8.18389 15.9256 7.6748 15.814 7.20207Z",
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_587_2986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.744141 3.92932L5.58144 8.65659L8.18609 6.43841L17.1163 5.02023V-0.0706787H-0.744141V3.92932Z",
    fill: "#EA4335"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_587_2986",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.814 7.20207H8.18605V10.293H12.5767C12.1674 12.2566 10.4558 13.3839 8.18605 13.3839C5.50698 13.3839 3.34884 11.2748 3.34884 8.65662C3.34884 6.03843 5.50698 3.92934 8.18605 3.92934C9.33953 3.92934 10.3814 4.32934 11.2 4.98389L13.5814 2.65662C12.1302 1.42025 10.2698 0.656616 8.18605 0.656616C3.64651 0.656616 0 4.22025 0 8.65662C0 13.093 3.64651 16.6566 8.18605 16.6566C12.2791 16.6566 16 13.7475 16 8.65662C16 8.18389 15.9256 7.6748 15.814 7.20207Z",
    fill: "white"
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_587_2986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-0.744141 13.3839L10.4186 5.02023L13.3582 5.38387L17.1163 -0.0706787V17.3839H-0.744141V13.3839Z",
    fill: "#34A853"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_587_2986",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 17
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.814 7.20207H8.18605V10.293H12.5767C12.1674 12.2566 10.4558 13.3839 8.18605 13.3839C5.50698 13.3839 3.34884 11.2748 3.34884 8.65662C3.34884 6.03843 5.50698 3.92934 8.18605 3.92934C9.33953 3.92934 10.3814 4.32934 11.2 4.98389L13.5814 2.65662C12.1302 1.42025 10.2698 0.656616 8.18605 0.656616C3.64651 0.656616 0 4.22025 0 8.65662C0 13.093 3.64651 16.6566 8.18605 16.6566C12.2791 16.6566 16 13.7475 16 8.65662C16 8.18389 15.9256 7.6748 15.814 7.20207Z",
    fill: "white"
  }))), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_587_2986)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.116 17.3839L5.58115 8.65665L4.09277 7.56575L17.116 3.92938V17.3839Z",
    fill: "#4285F4"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleIcon);
export default __webpack_public_path__ + "static/media/google-icon.c64dc8ab7946bbbb198f1c0c7f97886f.svg";
export { ForwardRef as ReactComponent };